module.exports = __webpack_public_path__ + "img/order.24025698.png";